import Vue from 'vue';
import store from '../src/store/store';

const alertSuscription = async () => {
  let subscription = Vue.ws.socket.getSubscription(`ALERTS`);
  if (!subscription) {
    subscription = Vue.ws.subscribe(`ALERTS`);
  }
  subscription.on('onConnected', data => {
    // console.log('Connected succesfully', data)
  });
  subscription.on('onAlert', data => {
    if (
      parseInt(data.alerta.user_id) ===
      parseInt(store.state.usuarioId)
    ) {
      store.commit('SET_ALERTA', data.alerta);
    }
  });
};

export default async () => {
  return new Promise((resolve, reject) => {
    Vue.ws.disconnect();
    Vue.ws.connect(
      {
        // wsDomain: "ws://localhost:3333",
        // wsDomain:
        //   store.state.base_socket + '://ecotronica.dev.cosmosti.com',
        wsDomain:
          store.state.base_socket +
          '://app.tarjetasecotronica.com:3333',
        jwtToken: null,
      },
      {
        path: 'adonis-ws',
        reconnectionAttempts: 300,
        reconnectionDelay: 5000,
      }
    );
    Vue.ws.socket.on('open', () => {
      // userTopicSubscriptions(1);
      alertSuscription();
      resolve();
    });

    // FOR EXAMPLE you can observe for userId or another variable from Vuex
    // store.watch(
    //   () => store.getters.getUserId,
    //   async id => {
    //     if (id) {
    //       alertSuscription(id);
    //     }
    //   }
    // );
  });
};
